export default "__VITE_ASSET__CTL0$Rc2__"